"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateId = void 0;
let seed = 1;
/**
 * Generowanie ID
 *
 * @export
 * @param {string} [prefix='id']
 * @return {string}
 */
function generateId(prefix = 'id') {
    if (!prefix) {
        prefix = 'id';
    }
    return `${prefix}_${seed++}`;
}
exports.generateId = generateId;
//# sourceMappingURL=generateId.js.map